"use client";

import React from "react";
import { FileText, UserCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const candidates = [{
  firstName: "Giorgio",
  lastName: "ASCENZI"
}, {
  firstName: "Maria",
  lastName: "BATTISTINI"
}, {
  firstName: "Carlo",
  lastName: "CIULLO"
}, {
  firstName: "Paola",
  lastName: "FANTOZZI"
}, {
  firstName: "Giovanni",
  lastName: "IMPERI"
}, {
  firstName: "Francesca",
  lastName: "LORI"
}, {
  firstName: "Guido",
  lastName: "MARTINI"
}, {
  firstName: "Luca",
  lastName: "NARDI"
}, {
  firstName: "Giancarlo",
  lastName: "NARDI"
}, {
  firstName: "Francesca",
  lastName: "PAUDICE"
}, {
  firstName: "Silvia",
  lastName: "ROSATI"
}, {
  firstName: "Clara",
  lastName: "SORIANI"
}, {
  firstName: "Luciana",
  lastName: "TACCHIA"
}, {
  firstName: "Claudio",
  lastName: "TARICIOTTI"
}, {
  firstName: "Karim",
  lastName: "THIB"
}, {
  firstName: "Saraswati",
  lastName: "VINCIGUERRA"
}, {
  firstName: "Giuseppe",
  lastName: "VITTORINI"
}];
export default function RemarkableCareers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234423" id="candidateslist3" className="relative w-full overflow-hidden bg-background px-8 py-24 md:px-16 lg:py-32 text-foreground">
      <div className="pointer-events-none absolute -bottom-1/2 -right-1/4 h-[800px] w-[800px] rounded-lg bg-gradient-to-br from-primary/10 to-secondary/5 opacity-30 blur-3xl" aria-hidden="true" />

      <div ref={ref} className={`mx-auto max-w-5xl transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <div className="mb-16 flex flex-col items-center text-center">
          <div className="border-l-4 border-primary pl-6 text-left md:text-center md:border-l-0 md:pl-0">
            <span className="mb-4 block tracking-wider uppercase !text-4xl !font-bold text-foreground">Candidati movimento 5 stelle</span>
          </div>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-muted-foreground">
            In ottemperanza alla legge sulla trasparenza, rendiamo pubblici i profili e i documenti legali di tutti i cittadini. Per ogni candidato sono disponibili il Curriculum Vitae (CV) e il Casellario Giudiziale.
          </p>
        </div>

        <div className="flex flex-col">
          <div className="overflow-x-auto rounded-lg border border-border bg-white shadow-sm">
            <Table>
              <TableHeader className="bg-muted/50">
                <TableRow>
                  <TableHead className="w-[60px] text-center font-bold">#</TableHead>
                  <TableHead className="font-bold">Candidato</TableHead>
                  <TableHead className="text-right font-bold">Documentazione</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {candidates.map((candidate, i) => <TableRow key={i} data-index={i} className="transition-colors hover:bg-gray-50">
                    <TableCell className="text-center font-medium text-muted-foreground">
                      {i + 1}
                    </TableCell>
                    <TableCell className="font-semibold text-foreground">
                      {candidate.firstName} {candidate.lastName}
                    </TableCell>
                    <TableCell className="text-right">
                      <div className="flex justify-end gap-2">
                        <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs font-semibold bg-blue-50 text-blue-600 border-blue-100 hover:bg-blue-100 hover:text-blue-700" asChild>
                          <Link to="#">
                            <FileText className="size-3.5" />
                            CV
                          </Link>
                        </Button>
                        <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs font-semibold bg-green-50 text-green-600 border-green-100 hover:bg-green-100 hover:text-green-700" asChild>
                          <Link to="#">
                            <UserCheck className="size-3.5" />
                            CASELLARIO
                          </Link>
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </section>;
}